import Breadcrumbs from '@material-ui/core/Breadcrumbs';
import Link from '@material-ui/core/Link';
import Typography from '@material-ui/core/Typography';
import { useNavigate } from 'react-router-dom';
import { OuterWrapper, useStyles } from './styles';
import { useTheme } from '@material-ui/core/styles';
import { useSelector } from 'react-redux';

const Breadcrumb = ({ header, parentHeader }) => {
  const theme = useTheme();
  const classes = useStyles(theme);
  const navigate = useNavigate();
  const uploadLoading = useSelector((state) => state.nonPersistedReducers.uploadSliceReducer.loading);
  const shopId = useSelector((state) => state.nonPersistedReducers?.shopSliceReducer?.shopId);

  const routeChange = (id) => {
    let path = `/shops/${shopId}/administration/galleries/${id}`;
    navigate(path);
  };

  return (
    <OuterWrapper>
      {header?.belongsTo ? (
        <Breadcrumbs aria-label='breadcrumb'>
          <Link
            className={classes.PGName}
            onClick={
              uploadLoading
                ? () => {}
                : () => {
                    routeChange(header?.belongsTo.id);
                  }
            }>
            {parentHeader?.belongsTo && '...'} {header?.belongsTo.name}
          </Link>
          <Typography className={classes.CGName}>{header?.name}</Typography>
        </Breadcrumbs>
      ) : (
        <Typography className={classes.CGName}>{header?.name}</Typography>
      )}
    </OuterWrapper>
  );
};
export default Breadcrumb;
